import { PasswordSchema as i, UsernameSchema as s, RefreshTokenSchema as c, BearerTokenTypeSchema as d, AccessTokenSchema as S, UserIdSchema as n } from "@hprofits/shared";
import { UserRoleSchema as t, PrivilegeSchema as g } from "@hprofits/shared/auth";
import { z as e } from "zod";
const j = e.object({
  username: s,
  password: i
}).strict().readonly(), r = e.string().min(1), k = e.object({
  username: s,
  password: i,
  captchaToken: r.optional()
}).strict().readonly(), T = e.object({
  siteKey: e.string().min(1)
}).readonly(), P = e.object({
  refresh_token: c
}).strict().readonly(), h = e.object({
  access_token: S,
  token_type: d,
  expires_in: e.number().int().positive(),
  refresh_token: c
}).readonly(), _ = h, b = e.object({
  id: n,
  username: s
}).readonly(), I = e.object({
  id: n,
  username: s,
  title: e.string().min(1).optional(),
  privileges: e.array(g).readonly(),
  roles: e.array(t).readonly(),
  activeRole: t.optional(),
  impersonatedBy: b.optional(),
  // `dict_user_grants` ids given to the user, e.g. the right to submit custom content. They belong to the user,
  // not to a role. Defaulted so that a client built with this field still reads the answer of a backend deployed
  // before it.
  grants: e.array(e.number().int()).readonly().default([])
}).readonly(), N = e.object({
  role: t
}).strict().readonly(), w = e.object({
  userId: n
}).readonly(), p = e.string().regex(/^[0-9a-f]{8}$/), x = e.object({
  slot: p
}).readonly(), E = e.object({
  id: n,
  email: e.string(),
  fullName: e.string(),
  isBanned: e.boolean()
}).readonly(), L = e.object({
  message: e.string()
}).readonly(), m = e.enum(["telegram"]), o = 100, l = 100, M = e.object({
  id: n,
  email: e.string(),
  isEmailVerified: e.boolean(),
  firstName: e.string(),
  lastName: e.string(),
  messenger: e.string().nullable(),
  messengerId: e.string().nullable(),
  isSubscribed: e.boolean()
}).readonly(), A = e.object({
  firstName: e.string().trim().min(1).max(o),
  lastName: e.string().trim().min(1).max(o),
  messenger: m.nullable(),
  messengerId: e.string().trim().min(1).max(l).nullable(),
  isSubscribed: e.boolean()
}).strict().readonly(), a = 6, U = e.object({
  oldPassword: e.string().min(1),
  newPassword: e.string().min(a)
}).strict().readonly(), y = t.extract(["Publisher", "Advert"]), v = e.object({
  firstName: e.string().trim().min(1).max(o),
  lastName: e.string().trim().min(1).max(o),
  email: s,
  messenger: m,
  messengerId: e.string().trim().min(1).max(l),
  password: e.string().min(a),
  roles: e.array(y).min(1).readonly(),
  isSubscribed: e.boolean(),
  acceptTerms: e.literal(!0),
  captchaToken: r.optional()
}).strict().readonly(), C = e.object({
  email: s,
  captchaToken: r.optional()
}).strict().readonly(), q = e.object({
  token: e.string().trim().min(1),
  password: e.string().min(a)
}).strict().readonly();
export {
  T as CaptchaConfigSchema,
  r as CaptchaTokenSchema,
  U as ChangePasswordSchema,
  E as ImpersonationUserSchema,
  j as LoginCredentialsSchema,
  L as MessageResponseSchema,
  a as PASSWORD_MIN_LENGTH,
  l as PROFILE_MESSENGER_ID_MAX_LENGTH,
  o as PROFILE_NAME_MAX_LENGTH,
  C as PasswordResetRequestSchema,
  q as PasswordResetSchema,
  m as ProfileMessengerSchema,
  M as ProfileSchema,
  P as RefreshTokenRequestSchema,
  _ as RefreshTokenResponseSchema,
  y as RegistrationRoleSchema,
  v as RegistrationSchema,
  b as SessionImpersonatorSchema,
  k as SessionLoginSchema,
  N as SessionRoleRequestSchema,
  p as SessionSlotSchema,
  I as SessionUserSchema,
  w as StartImpersonationRequestSchema,
  x as StartImpersonationResultSchema,
  h as TokenResponseSchema,
  A as UpdateProfileSchema
};
//# sourceMappingURL=schemas.js.map
